import { getEnv, Environment } from './getEnv';

/**
 * The API key used to access the site's BugHerd project.
 * @type { string }
 */
export const BUGHERD_API_KEY = 'dh9nfnvarb3nnhkwn15mng';

/**
 * Determines whether or not the current environment allows for the
 * BugHerd script to be used.
 * 
 * @returns { boolean }
 */
export function isValidBugherdEnvironment() {
    return ( getEnv( window.location.hostname ) === Environment.PPRD );
}

/**
 * Injects a script tag into the document to allow for the BugHerd
 * interactive overlay.
 * 
 * @param { string } apiKey - The API key for the BugHerd project.
 */
export function importBugherd( apiKey ) {
    const script = document.createElement( 'script' );

    script.id = 'bugherd';
    script.type = 'text/javascript';
    script.src = `https://www.bugherd.com/sidebarv2.js?apikey=${ apiKey }`;
    script.async = true;

    document.head.appendChild( script );
}

/**
 * Imports the BugHerd overlay script if the environment is appropriate.
 * If the environment is not appropriate, the script won't be imported.
 * 
 * @returns { boolean }
 */
export function inviteBugherd() {
    if ( isValidBugherdEnvironment() ) {
        importBugherd( BUGHERD_API_KEY );
        return true;
    }
    return false;
}
